import { Button, Flex, Modal, Text } from '@mantine/core';
import { useEffect } from 'react';
import useDeleteIntegration from '@/hooks/api/integrations/useDeleteIntegration';
import { IntegrationInstance, IntegrationProvider } from '@/types/integrations.ts';
import {
  getFullTenantLabel,
  getIntegrationInstancePrimaryLabel,
} from '@/utils/integrationDisplay.ts';

type DeleteIntegrationNameDialogProps = {
  integration: IntegrationInstance;
  provider?: IntegrationProvider;
  onClose: () => void;
};

const DeleteIntegrationModal = ({ integration, provider, onClose }: DeleteIntegrationNameDialogProps) => {
  const { mutate: deleteIntegration, isPending, isSuccess } = useDeleteIntegration();
  const tenantLabel = getFullTenantLabel(integration.sharepoint_tenant_id);
  const connectionLabel = getIntegrationInstancePrimaryLabel(provider, integration);

  useEffect(() => {
    if (isSuccess) {
      onClose();
    }
  }, [isSuccess, onClose]);

  return (
    <Modal opened={true} onClose={onClose} title="Delete Integration" centered>
      <Text size="sm">Delete connection {connectionLabel}?</Text>
      {tenantLabel && (
        <Text size="sm" c="#757575" mt="xs">
          {tenantLabel}
        </Text>
      )}
      <Flex mt="md" justify="flex-end" gap={'sm'}>
        <Button variant="outline" color="gray" onClick={onClose} disabled={isPending}>
          Cancel
        </Button>
        <Button
          color="red"
          variant="filled"
          onClick={() => deleteIntegration({ integrationId: integration.id })}
          loading={isPending}
        >
          Yes, delete
        </Button>
      </Flex>
    </Modal>
  );
};

export default DeleteIntegrationModal;
